import { useState } from 'react';
import { flushSync } from 'react-dom';

export type UseFormFieldsModalsStateReturnType = {
  currentlyActiveFormFieldIndex: number | null;
  setCurrentlyActiveFormFieldIndex: (fieldIndex: number | null) => void;

  fieldDetailsModal: {
    isOpen: boolean;
    open: (fieldIndex: number | null) => void;
    close: () => void;
  };
};

export function useFormFieldsModalsState(): UseFormFieldsModalsStateReturnType {
  const [isFieldDetailsModalOpen, setIsFieldDetailsModalOpen] = useState(false);
  const [currentlyActiveFormFieldIndex, setCurrentlyActiveFormFieldIndex] =
    useState<number | null>(null);

  const openFieldDetailsModal = (field: number | null) => {
    flushSync(() => setCurrentlyActiveFormFieldIndex(field));
    setIsFieldDetailsModalOpen(true);
  };

  const closeFieldDetailsModal = () => {
    flushSync(() => setIsFieldDetailsModalOpen(false));
    setCurrentlyActiveFormFieldIndex(null);
  };

  return {
    currentlyActiveFormFieldIndex,
    setCurrentlyActiveFormFieldIndex,

    fieldDetailsModal: {
      isOpen: isFieldDetailsModalOpen,
      open: openFieldDetailsModal,
      close: closeFieldDetailsModal,
    },
  };
}
